import { httpClient } from './http-client';
import type { ApiResponse } from './api.types';

export interface ClasificacionItem {
  idSegmento: string;
  segmento: string;
  idFamilia: string;
  familia: string;
  idClase: string;
  clase: string;
  idProducto: string;
  producto: string;
}

export const clasificacionesService = {
  buscar: (codigo: string, pagina = 1, tamanoPagina = 20): Promise<ApiResponse<ClasificacionItem[]>> =>
    httpClient.get<ClasificacionItem[]>('/clasificaciones', { codigo, pagina, tamanoPagina }),
};
